<template>
    <h1 class="title">
        <template v-if="projectNameSchema">{{projectNameSchema.projectMessages.createProject}}</template>
        <template v-if="!isRename && projectNameSchema">
            {{projectNameSchema.project_name_field.value}}
            <a href="javascript:;" @click.stop="renameProject" class="btn-light btn">{{projectNameSchema.projectMessages.change}}</a>
        </template>
        <template v-else>
            <div  v-if="projectNameSchema" class="rename-buttons">
                <ui-input-field :field="projectNameSchema.project_name_field"
                                v-model="projectName"></ui-input-field>
                <a href="javascript:;" @click.stop="saveProjectName" class="btn-std btn">
                    {{projectNameSchema.projectMessages.save}}
                </a>
                <a href="javascript:;" @click.stop="cancelRename" class="btn-light btn">
                    {{projectNameSchema.projectMessages.cancel}}
                </a>
            </div>
        </template>
    </h1>
</template>

<script>
    import {mapGetters} from 'vuex';
    import uiInputField from "vueComponents/ui-elements/fields/Input";

    /**
     * Компонент для изменения названия проекта
     *
     *  - projectNameSchema - данные с бэка с учетом языка
     *  <ui-input-field> - инпут для изменения названия
     *
     * @vuedoc
     * @module vue:components/ProjectName
     * @exports vue:components/ProjectName
     */
    export default {
        name: "project-name",

        props: ['project_id', 'project_name'],

        components: {
            'ui-input-field': uiInputField,
        },

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {boolean} isRename - Флаг, активна ли возможность изменения названия проекта
         * @property {string} projectName - Название проекта
         */
        data() {
            return {
                isRename: false,
                projectName: this.project_name,
            }
        },

        computed: {

            ...mapGetters('project', [
                'projectNameSchema'
            ]),
        },

        mounted() {
            this.$store.dispatch('project/getProjectNameSchema', this.project_id);
        },


        watch: {
            projectNameSchema() {
                if (this.projectNameSchema) {
                    if (this.projectNameSchema.project_name_field.success) {
                        this.isRename = false;
                    }
                }


            }
        },

        methods: {

            /**
             *  Переименовать проект
             *
             * @method renameProject
             */
            renameProject() {
                this.isRename = true;
                this.$store.dispatch('project/getProjectNameSchema', this.project_id);
            },

            /**
             *  Отменить смену названия
             *
             * @method cancelRename
             */
            cancelRename() {
                this.isRename = false;
                this.$store.dispatch('project/getProjectNameSchema', this.project_id);
            },

            /**
             *  Изменяет название проекта
             *
             * @method saveProjectName
             */
            saveProjectName() {
                this.$store.dispatch('project/renameProject', {
                    "projectId": this.project_id,
                    "newProjectName": this.projectName
                });
            },
        }
    }


</script>